import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=1f51ae6d"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f51ae6d')) {
      api.createRecord('1f51ae6d', component.options)
    } else {
      api.reload('1f51ae6d', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=1f51ae6d", function () {
      api.rerender('1f51ae6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/Calendar.vue"
export default component.exports